export { default } from './comment-avatar';
